import React, { useState, useEffect } from "react";
import { useParams,Link } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import {addThousandPoint,GetShotDateString,ChangeSimpleDateString} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

//교재 구매 내역
export const TextBookDetail = () => {
  let { bh_idx,terms } = useParams();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //교재 구매 정보
  const [varTextBookInfo,setTextBookInfo] = useState({});
  const [varTextBookList,setTextBookList] = useState([]);

  //센터 정보 호출
  const GetTextBookInformation = async() => {
    const sendData = {bh_idx:bh_idx,terms:terms};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_textbook_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const dataInfo = datas.results[0];
        const dataList = datas.results;
        let tnum = 0; 
        let tprice = 0;
        for(let i = 0; i < dataList.length; i++) {
          const dataArray = dataList[i];
          tnum += dataArray.tbl_number;
          let amount = dataArray.tbl_number * dataArray.tbl_price;
          tprice += amount;
        }
        setTextBookInfo({bh_name:dataInfo.bh_company,sdate:dataInfo.tb_rdate,tnum:tnum,tprice:tprice});
        setTextBookList(dataList);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'SETTLEMENT',item:'TextBook'});
    console.log(varAdminMenus);
  
    GetTextBookInformation();     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'교재 확인'} varDirection={"정산현황"}/>
        <div className="admin-content">
          <div style={{marginBottom:"10px"}}>
            <p><span>센터</span><span style={{marginLeft:"30px"}}>{varTextBookInfo.bh_name}</span></p>
          </div>
          <div style={{marginBottom:"10px"}}>
            <p><span>작성일</span><span style={{marginLeft:"30px"}}>{GetShotDateString(varTextBookInfo.sdate)}</span></p>
          </div>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="15%"/><col width="25%"/><col width="10%"/><col width="10%"/><col width="20%"/><col width="20%"/></colgroup>
              <thead>
                <tr>
                  <th style={{textAlign:"center",paddingLeft:"0px"}}>신청일</th>
                  <th style={{textAlign:"center",paddingLeft:"0px"}}>과목</th>
                  <th style={{textAlign:"center",paddingLeft:"0px"}}>단계</th>
                  <th style={{textAlign:"center",paddingLeft:"0px"}}>수량</th>
                  <th style={{textAlign:"center",paddingLeft:"0px"}}>가격</th>
                  <th style={{textAlign:"right",paddingLeft:"0px",paddingRight:"30px"}}>계</th>
                </tr>
              </thead>
              <tbody>
                {varTextBookList.map((textbook,i)=>(
                  <tr key={'textbook_'+i}>
                    <td style={{textAlign:"center"}}>{ChangeSimpleDateString(textbook.tb_rdate)}</td>
                    <td style={{textAlign:"center"}}>{textbook.vb_vt_mode===1?"수/연산":"감각/기하"}</td>
                    <td style={{textAlign:"center"}}>{textbook.vb_vt_name}</td>
                    <td style={{textAlign:"center"}}>{textbook.tbl_number}</td>
                    <td style={{textAlign:"center"}}>{addThousandPoint(textbook.tbl_price)}</td>
                    <td style={{textAlign:"right",paddingRight:"30px"}}>{addThousandPoint(textbook.tbl_number*textbook.tbl_price)}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={2} style={{textAlign:"center"}}>합계</td>
                  <td style={{textAlign:"center"}}>{addThousandPoint(varTextBookInfo.tnum)}</td>
                  <td colSpan={2} style={{textAlign:"right",paddingRight:"30px"}}>{addThousandPoint(varTextBookInfo.tprice)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{width:"100%",marginTop:"10px",textAlign:"center"}}>
            <Link to={'/Admin/TextBookList'} className="btn line" style={{width:"100px"}}>목록</Link>&nbsp;
          </div>
        </div>
    </div>
  );
}
export  default TextBookDetail;